import { render, staticRenderFns } from "./AnnotationTag.vue?vue&type=template&id=fce45a26&"
import script from "./AnnotationTag.vue?vue&type=script&lang=js&"
export * from "./AnnotationTag.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VExpandTransition,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce45a26')) {
      api.createRecord('fce45a26', component.options)
    } else {
      api.reload('fce45a26', component.options)
    }
    module.hot.accept("./AnnotationTag.vue?vue&type=template&id=fce45a26&", function () {
      api.rerender('fce45a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/AnnotationTag.vue"
export default component.exports